'use client';
import { CopyrightText } from './CopyrightsText/CopyrightsText';
import { AppsLinks } from '@intigral/shared/components/AppsLinks';
import { SocialLinks } from '@intigral/shared/components/SocialLinks';
import { IFooterProps } from '../../interface/iFooter';
import styles from './copy.module.sass';
import cn from 'classnames';
import { Menu } from '@intigral/shared/components/Menu';

export const Footer = ({
    navLinks,
    appsLinks,
    socialMediaLinks,
    copyrightText,
    LinkComponent,
    logoSrc,
    noPaddingTop = false,
}: IFooterProps) => {
    return (
        <footer id={styles.footer} style={{ paddingTop: noPaddingTop ? '0' : 'auto' }}>
            <div className={cn(styles.container, 'container', 'full-width')} id="test">
                {/* id is the portal target, see useMobileMenuPortal */}
                <div className={styles.holder} id="ifshowmobilmenu">
                    <Menu className={styles.menu} navLinks={navLinks} LinkComponent={LinkComponent} />
                    {logoSrc && <img className={styles.logo} src={logoSrc} alt="" />}
                </div>
                <div>
                    {appsLinks ? <AppsLinks links={appsLinks} LinkComponent={LinkComponent} /> : ''}
                    {socialMediaLinks ? <SocialLinks links={socialMediaLinks} LinkComponent={LinkComponent} /> : ''}
                    <CopyrightText text={copyrightText} />
                </div>
            </div>
        </footer>
    );
};
